import { V4UUID } from '@/firebase/database';
import { v4 } from 'uuid';
import { useNodeCanvasStore } from '../../store';
import { CanvasItem, Position } from './canvasObjects';
import { Node } from './node';

export class Topic implements CanvasItem {
  position: Position;
  id: V4UUID;
  name: string;
  radius: number;
  width: number;
  height: number;
  color: string;
  msgType: V4UUID; // id of msgType Integer
  packageId?: V4UUID;
  constructor(
    id: V4UUID = v4(),
    x: number = 0,
    y: number = 0,
    name: string = '',
    width: number = 150,
    height: number = 50,
    radius: number = 15,
    color: string = 'skyblue',
    msgType: V4UUID = '8b59b8e2-b9f2-499f-84e5-6bfe43d1e53a',
    packageId: V4UUID | undefined = undefined
  ) {
    this.id = id;
    this.position = { x: x, y: y };
    this.name = name;
    this.width = width;
    this.height = height;
    this.radius = radius;
    this.color = color;
    this.msgType = msgType;
    this.packageId = packageId;
  }

  fromJSON(args: any) {
    return Topic.fromJSON(args);
  }
  /**
   * Returns the name of the topic without the leading slash, if one exists
   */
  getNameNoFirstSlash() {
    return this.name
      .replace(/^~|~/g, function (match, index) {
        // removing all ~ characters unless they are at the start
        return index === 0 ? match : '';
      })
      .replace(/^\//, '')
      .replace(/[^a-zA-Z0-9_~{}\/]/g, ''); // removing all invalid characters
  }
  /**
   * @param {*} jsonTopic - The topic as an object converted from a json string
   */
  static fromJSON(jsonTopic: any) {
    const topic = new Topic(
      jsonTopic.id,
      jsonTopic.position ? jsonTopic.position.x : jsonTopic.x,
      jsonTopic.position ? jsonTopic.position.y : jsonTopic.y,
      jsonTopic.name,
      jsonTopic.width,
      jsonTopic.height,
      jsonTopic.radius,
      jsonTopic.color,
      jsonTopic.msgType,
      jsonTopic.packageId
    );
    return topic;
  }

  getPosition: () => Position = () => this.position;
  setPosition = (x: number, y: number) => (this.position = { x: x, y: y });
}
